// 选择志愿和面试方式

const NslcSelect = r => require.ensure(
  [],
  () => r(require('@/components/volunteer-audition/nslc-select.vue')),
  'NslcSelect'
)

export default [
  // NSLC选择志愿
  {
    path: '/VNslcSelect',
    name: 'VNslcSelect',
    component: NslcSelect
    // meta: {
    //   title: '选择志愿和面试方式'
    // }
  }
]



// WEBPACK FOOTER //
// ./src/router/sub-route/volunteer-audition.js